import { render, staticRenderFns } from "./WindowSizeAndGlazing.vue?vue&type=template&id=544cd1bd&scoped=true"
import script from "./WindowSizeAndGlazing.vue?vue&type=script&lang=ts"
export * from "./WindowSizeAndGlazing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544cd1bd",
  null
  
)

export default component.exports